<template>

<!-- <div class="row mx-4 mt-2" :style="{height:75+'px'}">
  
    <h6 >{{buildTitle()}}</h6> 
      <div  @mouseenter="openTooltip" @mouseleave="closeTooltip"  :style="{width:20+'px',height:20+'px',cursor: 'default'}" class="ml-2 rounded-circle text-center align-top bgnscblue small infohover"> <b> ? </b>
      </div><span :id='avg' :style="{position:'fixed',zindex:99}" class='border rounded bgnscblue p-2 small transit' >{{tooltip}}</span>
      
  </div> -->
  
<div class="row px-2 d-flex flex-row mt-4">
    <div class="" :style="{maxWidth:'700px'}">
      <h6>
      <span >{{
              buildTitle()
          }}</span>
    </h6>
    </div>
    
    <div class="">
    <div @mouseenter="openTooltip" @mouseleave="closeTooltip"  :style="{width:20+'px',height:20+'px',cursor: 'default',maxWidth:'800px'}" class="ml-1 rounded-circle text-center align-top bgnscblue small infohover"><b> ? </b></div>
    <span :id='avg' :style="{position:'fixed'}" class='border rounded bgnscblue p-2 small transit' >{{tooltip}}</span>
    </div>
  </div>  
<div class = "row justify-content-center">
    <apexchart
      width="450"
      type="pie"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>
  <script>
  import store from "../../store"
  
export default {
    props:['benchmark', 'question','tooltip','avg'],
    
    
    data: function() {
    return {
      popover:true,
      options: {
        colors: this.chooseColors(this.benchmark.length),
        labels: this.makeLabels(),
        legend: {
          position:'bottom'
        },
        dataLabels:{
          dropShadow: {
            enabled: false,
          }
        },
        plotOptions:{
        pie: {
          dataLabels: {
            offset: -35,        
          }, 
        }
        }
        },
      series: this.benchmark.slice(0,2),
      
    }
  },
  methods: {
    openTooltip(event) {
      this.popover=true
      let x = event.clientX
      let y = event.clientY
      let tooltip = document.getElementById(`${this.avg}`)
      
      tooltip.style.zIndex = 99
      tooltip.classList.toggle('transit')
      tooltip.style.left = x+15+'px'
      tooltip.style.top = y+15+'px'
      
    },
    closeTooltip(){
      let tooltip = document.getElementById(`${this.avg}`)
      
      
      tooltip.classList.toggle('transit')
      this.popover=false
    },
    showModal(modal, data) {
      
      store.showModal(modal, data);
    },
    hideModal() {
      store.hideModal();
    },
    chooseColors(int){
      return int < 3 ? ['#00853e','#006bab',] : ['#00853e', '#006bab', '#003a5c', ]
    },
    makeSeries(){

    },
    makeLabels(){
      return Object.keys(this.question.responses).length < 3 ? this.question.responses : ['Yes, and willing to share', 'Yes, and not willing to share', 'No']
    },
    buildTitle(){
      return `${this.question.title[0]} your company ${this.question.title[1]}`
    }
  },
  setup() {},
};
</script>
  
  